export default {
  namespaced: true,
  state: {
    hasFilledSurvey: false,
    isSurveyMandatory: true
  },
  mutations: {
    setHasFilledSurvey(state, status) {
      state.hasFilledSurvey = status;
    },
    setIsSurveyMandatory(state, status) {
      state.isSurveyMandatory = status;
    }
  }
};
